import React from "react";
import { Tag, Divider } from "antd";

const parameterType = (type, tag) => {
  switch (type) {
    case "Date":
      return (
        <>
          <Tag color="blue" key={tag.dateCalc}>
            Date Calc = {tag.dateCalc}
          </Tag>
          <Tag color="blue" key={tag.dateFormat}>
            Date Format = {tag.dateFormat}
          </Tag>
          <Tag color="blue" key={tag.dateInUtc}>
            Date In UTC =
            {tag.dateInUtc === true ? "true" : "false"}
          </Tag>
          <Tag color="blue" key={tag.useAsBusinessDate}>
            Use As Business Date =
            {tag.useAsBusinessDate === true ? "true" : "false"}
          </Tag>
        </>
      );
    case "Formatted":
      return (
        <>
          <Tag color="blue" key={tag.formatPatternString}>
            Format Pattern String = {tag.formatPatternString}
          </Tag>
        </>
      );
    case "Fixed":
      return (
        <>
          <Tag color="blue" key={tag.fixedvalue}>
            Value = {tag.fixedvalue}
          </Tag>
        </>
      );
    case "List":
      return (
        <>
          <Tag color="blue" key={tag.listvalue}>
            Value = {tag.listvalue}
          </Tag>
        </>
      );
    default:
      return (
        <>
          <Tag color="blue" key={tag}>
            Value = {tag}
          </Tag>
        </>
      );
  }
};

const JobParameterElement = (props) => {
  const { jobParameters } = props;
  return jobParameters.map((tag) => {
    if (!tag || Object.keys(tag).length === 0) {
      console.log("Empty tag found:", tag);
      return <span key="empty-tag">Invalid job parameter object detected</span>;
    }
    return (
      <>
        <Divider orientation="left">{tag.name}</Divider>
        <Tag color="blue" key={tag.name}>
          Parameter Name = {tag.name}
        </Tag>
        <Tag color="blue" key={tag.type}>
          Parameter Type = {tag.type}
        </Tag>
        {parameterType(tag.type, tag)}
      </>
    );
  });
};

export default JobParameterElement;
